import { render, staticRenderFns } from "./B_Home.vue?vue&type=template&id=43490438&scoped=true"
import script from "./B_Home.vue?vue&type=script&lang=js"
export * from "./B_Home.vue?vue&type=script&lang=js"
import style0 from "./B_Home.vue?vue&type=style&index=0&id=43490438&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43490438",
  null
  
)

export default component.exports